// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2z3Be","container":"styles_container__2DRvh","title":"styles_title__3jjc9","wrapper":"styles_wrapper__4mbyf","answer":"styles_answer__2RM-3"};